import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0f] border-t border-white/5 py-4 px-4 mt-auto">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-1 text-sm text-gray-400">
          <span className="text-center">
            © 2026 DevisFast
          </span>
          <span className="hidden md:inline mx-2">|</span>
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            <Link 
              to="/mentions-legales" 
              className="hover:text-[#1E40AF] transition-colors"
              data-testid="footer-mentions"
            >
              Mentions légales
            </Link>
            <span className="text-gray-600">|</span>
            <Link 
              to="/cgu" 
              className="hover:text-[#1E40AF] transition-colors"
              data-testid="footer-cgu"
            >
              CGU
            </Link>
            <span className="text-gray-600">|</span>
            <Link 
              to="/cgv" 
              className="hover:text-[#1E40AF] transition-colors"
              data-testid="footer-cgv"
            >
              CGV
            </Link>
            <span className="text-gray-600">|</span>
            <Link 
              to="/privacy" 
              className="hover:text-[#1E40AF] transition-colors"
              data-testid="footer-privacy"
            >
              Confidentialité
            </Link>
            <span className="text-gray-600">|</span>
            <a 
              href="mailto:support@devisfast.fr" 
              className="hover:text-[#1E40AF] transition-colors"
              data-testid="footer-email"
            >
              support@devisfast.fr
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
